export default {
  confirm_cancel: "Confirmação de cancelamento",
  cancel_solicitation: "Deseja cancelar a solicitação?",
  cancel_solicitation_message:
    "Ao confirmar o cancelamento, não será mais possível alterar o status da solicitação",
  code: "Código da solicitação",
  visualize: "Visualizar solicitação",
  details: "Detalhes da solicitação",
  list_solicitations: "Lista de solicitações",
  update_solicitation: "Atualizar solicitação",
  attachment_sent: "Anexos enviados",
  attachment_peding: "Anexos pendentes",
  no_attachment_peding: "Não há arquivos pendentes",
  approve_solicitation: 'Confirma a Aprovação da Solicitação "{number}"?',
  adjustment_solicitation:
    'Para solicitar uma revisão em uma solicitação, o campo "Avaliação" é obrigatório.',
  reject_solicitation: "Confirme se o campo de Avaliação foi preenchido.",
  find_solicitation: "Encontrar solicitação",
  search_description:
    "Para encontrar os pacientes realize uma busca por Tipo de Solicitação, Procedimento, Ocupação/Sub-Ocupação ou Grupo, Classificação de prioridade, Data de solicitação, Município, Nome, CPF e CNS",
  no_solicitations: "Nenhuma solicitação encontrado",
  no_search_description:
    "Não foi possível encontrar nenhum registro com os dados fornecidos. Verifique os campos preenchidos e tente novamente",
  confirm_schedule_close: "Confirmação de encerramento",
  close_schedule: "Deseja encerrar a agenda?",
  close_schedule_message:
    "Ao confirmar o encerramento, não será mais possível alterar o status da agenda",
  options_attendance: "Opções de atendimento",
  select_attendance_type: "Selecione o tipo de atendimento",
  add_new_register: "Adicionar novo registro",
  not_search_file: "Nenhum arquivo encontrado",
  not_file: "Não encontramos arquivos vinculados a solicitação",
  not_observations_file: "Nenhuma observação encontrada",
  not_observations: "Não encontramos observações vinculados a solicitação",
  attachment: "Anexo",
  change_solicitation_status: "Alterar status da solicitação",
  change_solicitation_status_for_serviced:
    "Você está alterando o status da solicitação de (não-atendida) para (atendida)",
  change_solicitation_status_for_no_serviced:
    "Você está alterando o status da solicitação de (atendida) para (não-atendida)",
  protocol_details: "Detalhes do protocolo",
  egress: "Solic. ambulatorial egresso referente à",
  change_status:
    "Você está modificando o status da solicitação, alterando-o de {statusOne} para {statusTwo}",
  add_observation: "Adicionar observação",
  outdated_patient: "Informe o que está havendo com o cadastro do paciente",
  confirm_status_change: "Confirmação de alteração de status",
  return_regulation: "Deseja alterar o status para 'Avaliada'?",
  return_regulation_message:
    "A solicitação será enviada para ser regulada novamente. Não será posível reverter a ação.",
  remove_reference: "Remover referência",
  assessment_solicitation: "Avaliando solicitação",
  remover_unity_reference:
    'Você está prestes a remover a unidade de referência "{unity}" dessa solicitação.',
    include_cid_in_solicitation: 'Incluir CID na solicitação',
};
